﻿import ConfiguratorBuilding from '../classes/datalayer-configurator-building.js';
import ConfiguratorEvent from '../events/configurator-event.js';
import DatalayerConfiguratorBuildingItem from '../classes/datalayer-configurator-building-item.js';

const configuratorName = 'modular_building';
let allowAttributeChangeTrack = true;

export default {
    init: async () => {
        window.expivi._events.onChange.subscribe(async (event) => {
            if (event.name === 'attribute' && allowAttributeChangeTrack) {
                await trackItemChange(event.payload);
                allowAttributeChangeTrack = false;
            }

            if (event.name === 'fully_loaded') {
                document.querySelectorAll('button.v-expansion-panel-header').forEach((element) => {
                    element.addEventListener('click', trackStepChange);
                });
            }

            if (event.name === 'product_finished_loading') {
                allowAttributeChangeTrack = true;
            }
        });
        
        document.addEventListener('modular-config-pdf-downloaded', await trackDownload);
    }
};

async function trackStepChange(event) {

    const button = event.target.closest('button');

    if (!button) {
        return;
    }

    const stepHeader = button.querySelector('.step-header-name');

    if (!stepHeader) {
        console.warn('Step header not found');
        return;
    }

    const stepValue = stepHeader.innerText;

    const building = new ConfiguratorBuilding();
    building.action = 'change_step';
    building.step = stepValue;
    building.footprint = await getFootprintValue();
    building.footprintBase = await getFootprintCustomValue();
    building.totalValue = await getPriceValue();

    const dataLayerEvent = new ConfiguratorEvent(configuratorName, building);
    dataLayerEvent.push();
}

async function trackItemChange(eventPayload) {
    const stepValue = getStepValue();

    if (stepValue === '') {
        return;
    }

    const building = new ConfiguratorBuilding();
    building.action = eventPayload.attribute_id === 240931 ? 'change_orientation' : 'add_option';
    building.step = stepValue;
    building.item = new DatalayerConfiguratorBuildingItem(eventPayload.attribute_name, eventPayload.attribute_value_name);
    building.footprint = await getFootprintValue();
    building.footprintBase = await getFootprintCustomValue();
    building.totalValue = await getPriceValue();

    const dataLayerEvent = new ConfiguratorEvent(configuratorName, building);
    dataLayerEvent.push();
}

async function trackDownload() {
    const building = new ConfiguratorBuilding();
    building.action = 'pdf_download';
    building.step = 'complete';
    building.items = await getConfigurationPanels();
    building.footprint = await getFootprintValue();
    building.footprintBase = await getFootprintCustomValue();
    building.totalValue = await getPriceValue();

    const dataLayerEvent = new ConfiguratorEvent(configuratorName, building);
    dataLayerEvent.push();
}

function getStepValue() {
    const element = document.querySelector('.v-expansion-panel-header--active');

    if (element === null) {
        return '';
    }

    return element.innerText;
}

async function getFootprintValue() {
    return window.expivi.saveConfiguration(0, 0)
        .then((data) => {
            const width = data.configured_products[0].configuration.attributes.find(x => x.attribute_id === 240689).attribute_value_name.replace('m', '');
            const depth = data.configured_products[0].configuration.attributes.find(x => x.attribute_id === 240687).attribute_value_name.replace('m', '');
            return `${width}x${depth}`;
        });
}

async function getFootprintCustomValue() {
    return window.expivi.saveConfiguration(0, 0)
        .then((data) => {
            const width = data.configured_products[0].configuration.attributes.find(x => x.attribute_id === 248764).attribute_value_name;
            const depth = data.configured_products[0].configuration.attributes.find(x => x.attribute_id === 248765).attribute_value_name;
            return `${width}x${depth}`;
        });
}

async function getPriceValue() {
    return window.expivi.getPrice()
        .then(price => price);
}

async function getConfigurationPanels() {
    const itemsArray = [];

    return getConfigurationAttributes()
        .then(async (data) => {
            for (const attribute of data.filter(x => x.attribute_name)) {
                itemsArray.push(new DatalayerConfiguratorBuildingItem(attribute.attribute_name, attribute.attribute_value_name, null));
            }
        })
        .then(() => itemsArray);
}

async function getConfigurationAttributes() {
    return window.expivi.saveConfiguration(0, 0, undefined, undefined, { include_keys: true })
        .then(data => data.configured_products[0].configuration.attributes);
}